import React, { useEffect } from 'react';
import '../styles/HeroVideoSection.css';
import '../styles/HomePageAnimations.css';
import AboutSliderSection from '../components/AboutSliderSection';
import ServicesSection from '../components/ServicesSection';
import ChooseYourPathSection from '../components/ChooseYourPathSection';
import WhyChoosePsychMitraSection from '../components/WhyChoosePsychMitraSection';
import FoundersMessageSection from '../components/FoundersMessageSection';
import ArticlesSection from '../components/ArticlesSection';
import UpcomingEventsSection from '../components/UpcomingEventsSection';
import ContactBookingSection from '../components/ContactBookingSection';
import FAQSection from '../components/FAQSection';
import TestimonialsSection from '../components/TestimonialsSection';

function HomePage() {
  useEffect(() => {
    // Initialize WOW.js animations after page loads
    setTimeout(() => {
      if (window.WOW) {
        try {
          new window.WOW().init();
        } catch (e) {
          console.log('WOW.js not available');
        }
      }
    }, 500);

    // Intersection Observer for scroll-triggered animations as user scrolls down
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -50px 0px',
      threshold: 0.12
    };

    const scrollObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('pm-in-view', 'pm-visible');
          scrollObserver.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll(
      '.blog-one__single, .upcoming-events-card, .testimonial-one__single, .contact-booking-section .contact-one__form-box, .faq-section .accrodion, .faq-one .accrodion, .pm-reveal'
    );

    animatedElements.forEach((el) => {
      // Preserve hero video section without scroll reveal
      if (el.closest('.main-slider--bloom') || el.classList.contains('main-slider--bloom')) return;
      el.classList.add('pm-scroll-reveal');
      scrollObserver.observe(el);
    });

    // Initialize Testimonial Carousel after page loads
    setTimeout(() => {
      if (window.$) {
        try {
          const testimonialCarousel = window.$('.testimonial-one__carousel');
          if (testimonialCarousel.length && !testimonialCarousel.hasClass('owl-loaded')) {
            testimonialCarousel.owlCarousel({
              loop: true,
              autoplay: true,
              margin: 30,
              nav: true,
              dots: false,
              smartSpeed: 500,
              autoplayTimeout: 10000,
              navText: ['<span class="icon-left-arrow"></span>', '<span class="icon-right-arrow"></span>'],
              responsive: {
                0: { items: 1 },
                768: { items: 1 },
                992: { items: 1 },
                1200: { items: 1 }
              }
            });
          }
        } catch (e) {
          console.log('Testimonial Carousel not available');
        }
      }
    }, 500);

    // Initialize Magnific Popup for video links rendered by React
    setTimeout(() => {
      if (window.$ && window.$.fn && window.$.fn.magnificPopup) {
        try {
          window.$('.video-popup').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: true,
            fixedContentPos: false
          });
        } catch (e) {
          console.log('Magnific Popup not available');
        }
      }
    }, 500);

    // Initialize Swiper sliders rendered by React
    setTimeout(() => {
      if (window.$ && window.Swiper) {
        try {
          window.$('.thm-swiper__slider').each(function () {
            const slider = window.$(this);
            if (slider.data('swiper-initialized')) {
              return;
            }

            const options = slider.data('swiper-options');
            if (options) {
              new window.Swiper(this, options);
              slider.data('swiper-initialized', true);
            }
          });
        } catch (e) {
          console.log('Swiper not available');
        }
      }
    }, 500);

    return () => {
      scrollObserver.disconnect();
    };
  }, []);

  return (
    <>
      {/* Bloom-Inspired Hero Video Section with Floating Interactive Elements */}
      <section className="main-slider main-slider--bloom">
        {/* Background Video */}
        <div className="bloom-video-wrapper">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="bloom-video-bg"
            poster="/assets/images/homeslide.png"
          >
            <source src="/assets/homepage_video/Homepage Landscape.mp4" type="video/mp4" />
            <source src="assets/homepage_video/Homepage Landscape.mp4" type="video/mp4" />
          </video>
        </div>

        {/* Natural Cinematic Overlay */}
        <div className="bloom-video-overlay"></div>

        {/* Floating Interactive Chip (Left: Trust & Care) */}
        {/* <div className="bloom-floating-chip bloom-chip-left d-none d-lg-flex">
          <div className="bloom-chip-icon">
            <i className="fas fa-shield-heart" style={{ color: '#c4b5fd' }}></i>
          </div>
          <div className="bloom-chip-text">
            <div className="bloom-chip-title">
              <span>Safe Space</span>
              <span className="star-rating">★ 4.9/5</span>
            </div>
            <div className="bloom-chip-subtitle">100% Confidential Care</div>
          </div>
        </div> */}

        {/* Floating Interactive Chip (Right: Verified MHPs) */}
        {/* <div className="bloom-floating-chip bloom-chip-right d-none d-lg-flex">
          <div className="bloom-chip-icon">
            <i className="fas fa-user-doctor" style={{ color: '#c4b5fd' }}></i>
          </div>
          <div className="bloom-chip-text">
            <div className="bloom-chip-title">Verified MHPs</div>
            <div className="bloom-chip-subtitle">Licensed Therapists</div>
          </div>
        </div> */}

        {/* Main Content Area */}
        <div className="container bloom-hero-container">
          <div className="bloom-hero-content main-slider__content active">
            {/* Top Mindful Badge */}
            {/* <div className="bloom-badge">
              <span className="bloom-badge-pulse"></span>
              <span>Empathy • Healing • Growth</span>
            </div> */}

            {/* Pop-Out Main Title */}
            <h1 className="bloom-hero-title main-slider__title">
              You deserve <span className="bloom-highlight">care.</span>
            </h1>

            {/* Pop-Out Subtitle */}
            <p className="bloom-hero-tagline">
              Whether you're looking for answers, support, or simply a space that understands, <br className="d-none d-md-block" />
              <strong>PsychMitra</strong> is here for you.
            </p>

            {/* Pop-Out Action Buttons */}
            <div className="bloom-hero-btn-box main-slider__btn-box">
              <a
                href="#choose-your-path"
                onClick={(e) => {
                  e.preventDefault();
                  const section = document.getElementById('choose-your-path');
                  if (section) {
                    section.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="bloom-btn-primary thm-btn main-slider__btn-one"
              >
                <span>Find Your Path</span>
                <i className="fas fa-arrow-right"></i>
              </a>

              <a
                href="#services"
                onClick={(e) => {
                  e.preventDefault();
                  const section = document.getElementById('services');
                  if (section) {
                    section.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="bloom-btn-secondary thm-btn main-slider__btn-two"
              >
                <span>Explore PsychMitra</span>
                <i className="fas fa-compass"></i>
              </a>
            </div>

            {/* Category Focus Tags (Bloom Style) */}
            {/* <div className="bloom-category-pills">
              <span className="bloom-pill-tag">
                <i className="fas fa-seedling me-1"></i> Individual Therapy
              </span>
              <span className="bloom-pill-tag">
                <i className="fas fa-people-roof me-1"></i> Couples & Family
              </span>
              <span className="bloom-pill-tag">
                <i className="fas fa-brain me-1"></i> Stress & Anxiety
              </span>
              <span className="bloom-pill-tag">
                <i className="fas fa-heart-pulse me-1"></i> Self-Care Guides
              </span>
            </div> */}
          </div>
        </div>
      </section>

      {/* Interactive Sliding Showcase (MHPs, Audios, Community Wall, Grow Practice) */}
      <AboutSliderSection />

      {/* Services Section */}
      <ServicesSection />

      {/* Choose Your Path Section with Dropdown Toggles */}
      <ChooseYourPathSection />

      {/* Why Choose PsychMitra Section with animated pointers */}
      <WhyChoosePsychMitraSection />

      {/* Founder's Message Section */}
      <FoundersMessageSection />

      <FAQSection />

      {/* CTA Section Start */}
      {/* <section className="cta-one">
        <div className="cta-one__shape-1">
          <img src="assets/images/shapes/cta-one-shape-1.png" alt="" />
        </div>
        <div className="container">
          <div className="cta-one__inner">
            <p className="cta-one__text">This is a space where you can feel safe and supported</p>
            <div className="cta-one__btn-box">
              <a href="/services" className="cta-one__btn thm-btn">Join Now</a>
            </div>
          </div>
        </div>
      </section> */}

      {/* Dynamic Testimonials Section */}
      <TestimonialsSection />

      {/* Articles & Blogs Section */}
      <ArticlesSection />

      {/* Upcoming Events Section */}
      <UpcomingEventsSection />

      {/* Contact/Booking Section */}
      <ContactBookingSection />
    </>
  );
}

export default HomePage;
